import { useMutation } from "@tanstack/react-query"

import { unpauseCoachSubscription } from "./api"
import { QUERY_KEYS } from "../../constants"
import { queryClient } from "../../util/queryClient"

export const useUnpauseCoachSubscriptionMutation = () => {
  return useMutation({
    mutationFn: unpauseCoachSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.COACH_SUBSCRIPTION])
    },
  })
}
